import type { Plugin } from 'chart.js';
import DatalabelsPlugin from 'chartjs-plugin-datalabels';

export type { Options } from 'chartjs-plugin-datalabels/types/options';
export const Datalabels: Plugin = DatalabelsPlugin;
export { type Context } from 'chartjs-plugin-datalabels';
